import "./websrc.5a50b6c9.js";


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("lvi95", function(module, exports) {

$parcel$export(module.exports, "openConfirmModal", () => $fa7a918906298de0$export$f184eb19c298e819);
$parcel$export(module.exports, "openInfoModal", () => $fa7a918906298de0$export$a78d12e4a335aa);
// Reusable themed confirmation modal using existing modal styles
// Exported for use across pages. Example:
//   const ok = await openConfirmModal({ title: 'Confirm', message: 'Proceed?', confirmText: 'Yes', cancelText: 'No' });
function $fa7a918906298de0$export$f184eb19c298e819({ title: title = 'Confirm', message: message = 'Are you sure?', confirmText: confirmText = 'Yes', cancelText: cancelText = 'Cancel', confirmClass: confirmClass = '' } = {}) {
    return new Promise((resolve)=>{
        try {
            const ov = document.createElement('div');
            ov.className = 'modal-overlay';
            const confirmBtnClass = [
                'menu-btn',
                confirmClass
            ].filter(Boolean).join(' ');
            ov.innerHTML = `
        <div class="modal-dialog" role="dialog" aria-modal="true">
          <h3 style="margin-top:0;">${title}</h3>
          <p style="margin-top: 0.5rem;">${message}</p>
          <div class="modal-actions">
            <button id="confirm_ok" class="${confirmBtnClass}">${confirmText}</button>
            <button id="confirm_cancel" class="menu-btn">${cancelText}</button>
          </div>
        </div>
      `;
            let onKey;
            const cleanup = (val)=>{
                try {
                    window.removeEventListener('keydown', onKey);
                } catch  {}
                try {
                    ov.remove();
                } catch  {}
                resolve(val);
            };
            ov.addEventListener('click', (e)=>{
                if (e.target === ov) cleanup(false);
            });
            document.body.appendChild(ov);
            const okBtn = ov.querySelector('#confirm_ok');
            const cancelBtn = ov.querySelector('#confirm_cancel');
            okBtn?.addEventListener('click', ()=>cleanup(true));
            cancelBtn?.addEventListener('click', ()=>cleanup(false));
            onKey = (ev)=>{
                if (ev.key === 'Escape') {
                    ev.preventDefault();
                    cleanup(false);
                }
            };
            window.addEventListener('keydown', onKey);
        } catch  {
            // Fallback to native confirm if anything goes wrong
            resolve(confirm(message));
        }
    });
}
function $fa7a918906298de0$export$a78d12e4a335aa({ title: title = 'Notice', message: message = '', okText: okText = 'OK' } = {}) {
    return new Promise((resolve)=>{
        try {
            const ov = document.createElement('div');
            ov.className = 'modal-overlay';
            ov.innerHTML = `
        <div class="modal-dialog" role="dialog" aria-modal="true">
          <h3 style="margin-top:0;">${title}</h3>
          <p style="margin-top: 0.5rem;">${message}</p>
          <div class="modal-actions">
            <button id="info_ok" class="menu-btn">${okText}</button>
          </div>
        </div>
      `;
            let onKey;
            const cleanup = ()=>{
                try {
                    window.removeEventListener('keydown', onKey);
                } catch  {}
                try {
                    ov.remove();
                } catch  {}
                resolve(true);
            };
            ov.addEventListener('click', (e)=>{
                if (e.target === ov) cleanup();
            });
            document.body.appendChild(ov);
            const okBtn = ov.querySelector('#info_ok');
            okBtn?.addEventListener('click', cleanup);
            try {
                okBtn?.focus();
            } catch  {}
            onKey = (ev)=>{
                if (ev.key === 'Escape' || ev.key === 'Enter') {
                    ev.preventDefault();
                    cleanup();
                }
            };
            window.addEventListener('keydown', onKey);
        } catch  {
            alert(message);
            resolve(true);
        }
    });
}
var $fa7a918906298de0$export$2e2bcd8739ae039 = {
    openConfirmModal: $fa7a918906298de0$export$f184eb19c298e819,
    openInfoModal: $fa7a918906298de0$export$a78d12e4a335aa
};

});

parcelRegister("7Woub", function(module, exports) {
module.exports = import("gFhDz").then(()=>parcelRequire('laAR7'));

});

parcelRegister("aiphm", function(module, exports) {
module.exports = import("iq7MP").then(()=>parcelRequire('5C1ms'));

});

parcelRegister("fMDQv", function(module, exports) {
module.exports = Promise.all([
    import("kvnur"),
    import("l3eCz")
]).then(()=>parcelRequire('l0naP'));

});

parcelRegister("7TmJd", function(module, exports) {
module.exports = import("2YfEe").then(()=>parcelRequire('bFgvJ'));

});

parcelRegister("9V0qY", function(module, exports) {
module.exports = Promise.all([
    import("kvnur"),
    import("3Oarf")
]).then(()=>parcelRequire('6b60c'));

});

parcelRegister("jZu9F", function(module, exports) {
module.exports = Promise.all([
    import("kvnur"),
    import("d3rbr")
]).then(()=>parcelRequire('kYhpH'));

});

parcelRegister("i5Zt7", function(module, exports) {
module.exports = import("9bw45").then(()=>parcelRequire('lsZPt'));

});

parcelRegister("ext81", function(module, exports) {
module.exports = Promise.all([
    import("i30iK"),
    import("qdTP6"),
    import("eFduq")
]).then(()=>parcelRequire('5VBZS'));

});

parcelRegister("b54sn", function(module, exports) {
module.exports = Promise.all([
    import("i30iK"),
    import("qdTP6"),
    import("0215N")
]).then(()=>parcelRequire('7VXef'));

});

parcelRegister("g9Msy", function(module, exports) {
module.exports = import("2PLbU").then(()=>parcelRequire('75zYA'));

});

parcelRegister("bsykY", function(module, exports) {
module.exports = import("hQIOz").then(()=>parcelRequire('Qrkpo'));

});

parcelRegister("k3SVi", function(module, exports) {
module.exports = import("6OIah").then(()=>parcelRequire('9bBDF'));

});

parcelRegister("cbyNl", function(module, exports) {
module.exports = import("cBt4G").then(()=>parcelRequire('eXqFV'));

});

parcelRegister("3B2JW", function(module, exports) {
module.exports = import("TuVMx").then(()=>parcelRequire('b1ZwW'));

});

parcelRegister("3DmAX", function(module, exports) {
module.exports = import("el8Zi").then(()=>parcelRequire('lruu6'));

});

parcelRegister("6uCv7", function(module, exports) {
module.exports = import("kfyzD").then(()=>parcelRequire('hxJ05'));

});

parcelRegister("7L0kO", function(module, exports) {
module.exports = import("dST03").then(()=>parcelRequire('gvTIm'));

});

parcelRegister("izz4m", function(module, exports) {
module.exports = import("dln4h").then(()=>parcelRequire('4wgC0'));

});

parcelRegister("5O15m", function(module, exports) {
module.exports = import("8FRZh").then(()=>parcelRequire('dIC7o'));

});

parcelRegister("dNdvO", function(module, exports) {
module.exports = Promise.all([
    import("qdTP6"),
    import("8m5FF")
]).then(()=>parcelRequire('h9qHm'));

});

parcelRegister("hIvU5", function(module, exports) {
module.exports = import("lkrdt").then(()=>parcelRequire('idBLN'));

});

parcelRegister("bilr3", function(module, exports) {

$parcel$export(module.exports, "teamByID", () => $839200c19e9e84de$export$682f616b9b5b8ac1);
$parcel$export(module.exports, "confirmAndSetActiveTeamId", () => $839200c19e9e84de$export$c919d78376b53e8d);

var $67bV2 = parcelRequire("67bV2");

var $lvi95 = parcelRequire("lvi95");
function $839200c19e9e84de$var$escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, (ch)=>({
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#39;'
        })[ch]);
}
function $839200c19e9e84de$var$scopeName(teamID) {
    const id = Number(teamID || 0);
    if (!id) return 'your personal account';
    const team = ((0, $67bV2.state).teams || []).find((t)=>Number(t.team_id || 0) === id);
    return team?.name ? `team "${team.name}"` : `team ${id}`;
}
function $839200c19e9e84de$export$682f616b9b5b8ac1(teamID) {
    const id = Number(teamID || 0);
    return ((0, $67bV2.state).teams || []).find((t)=>Number(t.team_id || 0) === id) || null;
}
async function $839200c19e9e84de$export$c919d78376b53e8d(teamID) {
    const nextID = Number(teamID || 0);
    const next = Number.isFinite(nextID) && nextID > 0 ? nextID : 0;
    const current = Number((0, $67bV2.state).activeTeamId || 0);
    if (next === current) return true;
    let title = "\u26A0\uFE0F Change Scope";
    let confirmText = 'Change';
    if (!current && next) {
        title = "\u26A0\uFE0F Enter Team";
        confirmText = 'Enter Team';
    } else if (current && !next) {
        title = "\u26A0\uFE0F Exit Team";
        confirmText = 'Exit Team';
    } else if (current && next) {
        title = "\u26A0\uFE0F Switch Team";
        confirmText = 'Switch Team';
    }
    const nextName = $839200c19e9e84de$var$escapeHtml($839200c19e9e84de$var$scopeName(next));
    const currentName = $839200c19e9e84de$var$escapeHtml($839200c19e9e84de$var$scopeName(current));
    const message = `Switch from ${currentName} to ${nextName}?`;
    const ok = await (0, $lvi95.openConfirmModal)({
        title: title,
        message: message,
        confirmText: confirmText,
        cancelText: 'Cancel',
        confirmClass: 'danger-emoji-btn'
    });
    if (!ok) return false;
    (0, $67bV2.setActiveTeamId)(next);
    return true;
}

});


var $67bV2 = parcelRequire("67bV2");
parcelRequire("lvi95");
const $739f3ec41852a043$var$SITE_NAME = 'subseq.bio';
const $739f3ec41852a043$var$DEFAULT_TITLE = 'Subseq.bio - Protein Design Jobs';
const $739f3ec41852a043$var$FONT_PREVIEW_STACK_KEY = 'ssq_font_preview_stack';
function $739f3ec41852a043$var$applyStoredFontPreview() {
    try {
        const stack = localStorage.getItem($739f3ec41852a043$var$FONT_PREVIEW_STACK_KEY);
        if (stack) document.documentElement.style.setProperty('--font-mono', stack);
    } catch  {}
}
$739f3ec41852a043$var$applyStoredFontPreview();
const $739f3ec41852a043$var$routeTitles = {
    home: $739f3ec41852a043$var$DEFAULT_TITLE,
    updates: `Updates | ${$739f3ec41852a043$var$SITE_NAME}`,
    programs: `Programs | ${$739f3ec41852a043$var$SITE_NAME}`,
    'bio-agents': `Bio Agents | ${$739f3ec41852a043$var$SITE_NAME}`,
    workshop: `Workshop | ${$739f3ec41852a043$var$SITE_NAME}`,
    newtask: `New Task | ${$739f3ec41852a043$var$SITE_NAME}`,
    newjob: `New Task | ${$739f3ec41852a043$var$SITE_NAME}`,
    jobs: `Jobs | ${$739f3ec41852a043$var$SITE_NAME}`,
    pipelines: `Pipelines | ${$739f3ec41852a043$var$SITE_NAME}`,
    templates: `Templates | ${$739f3ec41852a043$var$SITE_NAME}`,
    viewjob: `Job Details | ${$739f3ec41852a043$var$SITE_NAME}`,
    projects: `Projects | ${$739f3ec41852a043$var$SITE_NAME}`,
    viewproject: `Project Details | ${$739f3ec41852a043$var$SITE_NAME}`,
    datasets: `Datasets | ${$739f3ec41852a043$var$SITE_NAME}`,
    newdataset: `New Dataset | ${$739f3ec41852a043$var$SITE_NAME}`,
    viewdataset: `Dataset Details | ${$739f3ec41852a043$var$SITE_NAME}`,
    viewdata: `Dataset Details | ${$739f3ec41852a043$var$SITE_NAME}`,
    funding: `Funding & Credits | ${$739f3ec41852a043$var$SITE_NAME}`,
    pricing: `Pricing | ${$739f3ec41852a043$var$SITE_NAME}`,
    keys: `API Keys | ${$739f3ec41852a043$var$SITE_NAME}`,
    team: `Team | ${$739f3ec41852a043$var$SITE_NAME}`,
    teams: `Teams | ${$739f3ec41852a043$var$SITE_NAME}`,
    test: `Font Test | ${$739f3ec41852a043$var$SITE_NAME}`
};























const $739f3ec41852a043$var$pageLoaders = {
    home: ()=>(parcelRequire("7Woub")),
    updates: ()=>(parcelRequire("aiphm")),
    newtask: ()=>(parcelRequire("fMDQv")),
    newjob: ()=>(parcelRequire("fMDQv")),
    jobs: ()=>(parcelRequire("7TmJd")),
    pipelines: ()=>(parcelRequire("9V0qY")),
    templates: ()=>(parcelRequire("jZu9F")),
    viewjob: ()=>(parcelRequire("i5Zt7")),
    viewdata: ()=>(parcelRequire("ext81")),
    viewdataset: ()=>(parcelRequire("ext81")),
    viewproject: ()=>(parcelRequire("b54sn")),
    projects: ()=>(parcelRequire("g9Msy")),
    datasets: ()=>(parcelRequire("bsykY")),
    newdataset: ()=>(parcelRequire("k3SVi")),
    funding: ()=>(parcelRequire("cbyNl")),
    pricing: ()=>(parcelRequire("3B2JW")),
    keys: ()=>(parcelRequire("3DmAX")),
    team: ()=>(parcelRequire("6uCv7")),
    teams: ()=>(parcelRequire("7L0kO")),
    programs: ()=>(parcelRequire("izz4m")),
    'bio-agents': ()=>(parcelRequire("5O15m")),
    workshop: ()=>(parcelRequire("dNdvO")),
    test: ()=>(parcelRequire("hIvU5"))
};
let $739f3ec41852a043$var$routeLeaveGuard = null;
let $739f3ec41852a043$var$routeViewContextProvider = null;
let $739f3ec41852a043$var$activeRoutePath = `${window.location.pathname}${window.location.search}`;
let $739f3ec41852a043$var$renderToken = 0;
let $739f3ec41852a043$var$closeJobInfoModal = null;
function $739f3ec41852a043$var$setRouteLeaveGuard(fn) {
    $739f3ec41852a043$var$routeLeaveGuard = typeof fn === 'function' ? fn : null;
    return ()=>{
        if ($739f3ec41852a043$var$routeLeaveGuard === fn) $739f3ec41852a043$var$routeLeaveGuard = null;
    };
}
function $739f3ec41852a043$var$setRouteViewContextProvider(fn) {
    $739f3ec41852a043$var$routeViewContextProvider = typeof fn === 'function' ? fn : null;
    return ()=>{
        if ($739f3ec41852a043$var$routeViewContextProvider === fn) $739f3ec41852a043$var$routeViewContextProvider = null;
    };
}
function $739f3ec41852a043$var$getRouteViewContext() {
    const path = `${window.location.pathname}${window.location.search}`;
    const { page: page } = $739f3ec41852a043$var$getRoute();
    const base = {
        path: path,
        page: page
    };
    if (typeof $739f3ec41852a043$var$routeViewContextProvider !== 'function') return base;
    try {
        const extra = $739f3ec41852a043$var$routeViewContextProvider();
        if (!extra || typeof extra !== 'object' || Array.isArray(extra)) return base;
        return {
            ...base,
            ...extra
        };
    } catch (_) {
        return base;
    }
}
async function $739f3ec41852a043$var$canLeaveRoute(nextPath, source = 'navigate') {
    if (typeof $739f3ec41852a043$var$routeLeaveGuard !== 'function') return true;
    const from = `${window.location.pathname}${window.location.search}`;
    const to = typeof nextPath === 'string' ? nextPath : from;
    if (to === from) return true;
    try {
        const result = await $739f3ec41852a043$var$routeLeaveGuard({
            from: from,
            to: to,
            source: source
        });
        return result !== false;
    } catch (err) {
        console.warn('route leave guard failed', err);
        return false;
    }
}
function $739f3ec41852a043$var$updateDocumentTitle(page) {
    try {
        const nextTitle = $739f3ec41852a043$var$routeTitles[page] || $739f3ec41852a043$var$DEFAULT_TITLE;
        if (document.title !== nextTitle) document.title = nextTitle;
    } catch  {}
}
function $739f3ec41852a043$var$normalizeLegacyHash() {
    const { hash: hash, pathname: pathname } = window.location;
    if (hash && hash.startsWith('#')) {
        const raw = hash.slice(1); // e.g. "jobs" or "viewjob?jobid=123"
        const [page, queryString] = raw.split('?');
        const path = page === 'home' ? '/' : `/${page}`;
        const qs = queryString ? `?${queryString}` : '';
        // Only rewrite if we're not already on a matching clean path
        if (pathname === '/' || pathname === '/index.html') window.history.replaceState({}, document.title, `${path}${qs}`);
    }
}
function $739f3ec41852a043$var$getRoute() {
    // Returns { page, params }
    const { pathname: pathname, search: search } = window.location;
    const clean = pathname.replace(/\/+$/, ''); // trim trailing slashes
    let page = clean === '' || clean === '/' ? 'home' : clean.slice(1); // remove leading '/'
    // Only keep the first path segment (e.g., '/jobs/123' -> 'jobs') for now
    if (page.includes('/')) page = page.split('/')[0];
    if (page === 'whats-new') page = 'updates';
    const params = new URLSearchParams(search);
    return {
        page: page,
        params: params
    };
}
function $739f3ec41852a043$var$canonicalizeRoutePath(path) {
    if (typeof path !== 'string') return path;
    try {
        const url = new URL(path, window.location.origin);
        if (url.origin === window.location.origin) {
            const pathname = url.pathname.replace(/\/+$/, '');
            if (pathname === '/newjob') return `/newtask${url.search}${url.hash}`;
            if (pathname === '/agents' || pathname === '/chat') return `/bio-agents${url.search}${url.hash}`;
        }
    } catch  {}
    return path;
}
function $739f3ec41852a043$var$scrollMainToTop() {
    try {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'auto'
        });
        const mc = document.getElementById('main-content');
        if (mc) {
            if (typeof mc.scrollTo === 'function') mc.scrollTo({
                top: 0,
                left: 0,
                behavior: 'auto'
            });
            mc.scrollTop = 0;
            mc.scrollLeft = 0;
        }
    } catch (e) {}
}
async function $739f3ec41852a043$var$loadAndMountPage(page, params, token) {
    const loader = $739f3ec41852a043$var$pageLoaders[page] || null;
    const pageName = loader ? page : 'home';
    const pageLoader = loader || $739f3ec41852a043$var$pageLoaders.home;
    if (!loader) console.error(`Page "${page}" not found`);
    try {
        const mod = await pageLoader();
        if (token !== $739f3ec41852a043$var$renderToken) return false;
        const mount = mod && mod.default;
        if (typeof mount !== 'function') throw new Error(`Page "${pageName}" does not export a default mount function.`);
        mount(loader ? params : new URLSearchParams());
        $739f3ec41852a043$var$updateDocumentTitle(pageName);
        return true;
    } catch (err) {
        console.error(`Failed to load page "${pageName}":`, err);
        if (token !== $739f3ec41852a043$var$renderToken) return false;
        const el = document.getElementById('main-content');
        if (el) el.innerHTML = '<div class="section main-area"><div class="narrow-page"><p class="error-message">Failed to load this page.</p></div></div>';
        $739f3ec41852a043$var$updateDocumentTitle(pageName);
        return false;
    }
}
async function $739f3ec41852a043$var$render() {
    $739f3ec41852a043$var$closeJobInfoModal?.();
    $739f3ec41852a043$var$closeJobInfoModal = null;
    const token = ++$739f3ec41852a043$var$renderToken;
    const { page: page, params: params } = $739f3ec41852a043$var$getRoute();
    $739f3ec41852a043$var$routeViewContextProvider = null;
    (0, $67bV2.runPageCleanup)();
    if (page === 'newjob') {
        window.history.replaceState({}, '', `/newtask${window.location.search || ''}`);
        await $739f3ec41852a043$var$render();
        return;
    }
    if (page === 'agents' || page === 'chat') {
        window.history.replaceState({}, '', `/bio-agents${window.location.search || ''}`);
        await $739f3ec41852a043$var$render();
        return;
    }
    if (page === 'pipeline' || page === 'newpipeline') {
        const nextParams = new URLSearchParams(params);
        nextParams.set('pipeline', '1');
        nextParams.set('config', '1');
        window.history.replaceState({}, '', `/newtask?${nextParams.toString()}`);
        await $739f3ec41852a043$var$render();
        return;
    }
    if (page === 'template') {
        window.history.replaceState({}, '', '/newtask?pipeline=1&config=1');
        await $739f3ec41852a043$var$render();
        return;
    }
    const docRedirects = {
        apiref: '/docs/api',
        guide: '/docs',
        rfdiff: '/docs/rfdiffusion',
        esmfold: '/docs/esmfold',
        esmfold2: '/docs/esmfold2',
        esmc: '/docs/esmc',
        ligandmpnn: '/docs/ligandmpnn',
        proteinmpnn: '/docs/ligandmpnn',
        af2: '/docs/alphafold2',
        openfold3: '/docs/openfold3',
        boltz1: '/docs/boltz1',
        boltzgen: '/docs/boltzgen',
        bioemu: '/docs/bioemu',
        bioemu2: '/docs/bioemu2',
        mmseqs2: '/docs/mmseqs2',
        diffdock: '/docs/diffdock-l',
        'diffdock-pp': '/docs/diffdock-pp',
        'shape-comp': '/docs/shape-comp',
        gromacs: '/docs/gromacs',
        pymolplus: '/docs/pymolplus',
        openmm: '/docs/openmm',
        freebindcraft: '/docs/freebindcraft',
        utility: '/docs/utility'
    };
    if (docRedirects[page]) {
        window.location.href = docRedirects[page];
        return;
    }
    const mounted = await $739f3ec41852a043$var$loadAndMountPage(page, params, token);
    if (token !== $739f3ec41852a043$var$renderToken) return;
    if (mounted) $739f3ec41852a043$var$scrollMainToTop();
    $739f3ec41852a043$var$activeRoutePath = `${window.location.pathname}${window.location.search}`;
}
// Public navigation helper
async function $739f3ec41852a043$var$navigate(path, options = {}) {
    if (typeof path !== 'string') return;
    if (!path.startsWith('/')) path = `/${path}`;
    path = $739f3ec41852a043$var$canonicalizeRoutePath(path);
    const url = new URL(path, window.location.origin);
    if (url.origin === window.location.origin && url.pathname.replace(/\/+$/, '') === '/viewjob') {
        $739f3ec41852a043$var$closeJobInfoModal?.();
        const mod = await $739f3ec41852a043$var$pageLoaders.viewjob();
        $739f3ec41852a043$var$closeJobInfoModal = mod.openJobInfoModal(url.searchParams, {
            onClose: ()=>{
                $739f3ec41852a043$var$closeJobInfoModal = null;
            }
        });
        return;
    }
    const force = !!(options && options.force);
    const sameRoute = window.location.pathname + window.location.search === path;
    if (sameRoute && !force) // no-op if same route
    return;
    const ok = await $739f3ec41852a043$var$canLeaveRoute(path, 'navigate');
    if (!ok) return;
    $739f3ec41852a043$var$closeJobInfoModal?.();
    $739f3ec41852a043$var$closeJobInfoModal = null;
    if (sameRoute) window.history.replaceState({}, '', path);
    else window.history.pushState({}, '', path);
    await $739f3ec41852a043$var$render();
}
// Expose helpers globally for inline handlers
window.navigate = $739f3ec41852a043$var$navigate;
window.route = $739f3ec41852a043$var$render;
window.setRouteLeaveGuard = $739f3ec41852a043$var$setRouteLeaveGuard;
window.setRouteViewContextProvider = $739f3ec41852a043$var$setRouteViewContextProvider;
window.getRouteViewContext = $739f3ec41852a043$var$getRouteViewContext;
// Intercept internal link clicks
document.addEventListener('click', (e)=>{
    let anchor = null;
    const t = e.target;
    if (t && typeof t.closest === 'function') anchor = t.closest('a');
    if (!anchor) return;
    const href = anchor.getAttribute('href');
    if (!href) return;
    // Ignore links that should not be router-intercepted
    // - downloads
    // - explicit new-tab targets
    // - external markers
    // - API endpoints (e.g., file downloads)
    if (anchor.hasAttribute('download') || anchor.getAttribute('target') === '_blank' || anchor.getAttribute('rel') === 'external' || href.startsWith('/api/')) return; // allow browser default behavior
    // Only intercept same-origin, root-relative links
    const url = new URL(href, window.location.origin);
    const isSameOrigin = url.origin === window.location.origin;
    const isAppLink = href.startsWith('/') && !href.startsWith('//');
    if (isSameOrigin && isAppLink) {
        // Standalone static pages served outside the SPA (full page loads)
        const isStandalone = url.pathname === '/docs' || url.pathname === '/docs.html' || url.pathname.startsWith('/docs/') || url.pathname === '/contact';
        if (isStandalone) return;
        e.preventDefault();
        $739f3ec41852a043$var$navigate(url.pathname + url.search);
    }
});
// Handle back/forward
window.addEventListener('popstate', async ()=>{
    const targetPath = `${window.location.pathname}${window.location.search}`;
    const prevPath = $739f3ec41852a043$var$activeRoutePath;
    const ok = await $739f3ec41852a043$var$canLeaveRoute(targetPath, 'popstate');
    if (!ok) {
        window.history.pushState({}, '', prevPath);
        return;
    }
    await $739f3ec41852a043$var$render();
});
// Normalize legacy hash routes once, then render current route
$739f3ec41852a043$var$normalizeLegacyHash();
$739f3ec41852a043$var$render();



var $67bV2 = parcelRequire("67bV2");

var $lvi95 = parcelRequire("lvi95");

var $bilr3 = parcelRequire("bilr3");

var $9MHdv = parcelRequire("9MHdv");
const $8420f99a62349403$var$BIO_AGENT_EXPERIMENT_ACK_KEY = 'ssq_bio_agent_experiment_ack_v1';
const $8420f99a62349403$var$BIO_AGENT_EXPERIMENT_LEGACY_ACK_KEY = 'ssq_chat_experiment_ack_v1';
const $8420f99a62349403$var$BIO_AGENT_NAV_COUNT_POLL_MS = 15000;
const $8420f99a62349403$var$BIO_AGENT_NAV_COUNT_BACKOFF_MAX_MS = 60000;
const $8420f99a62349403$var$isActiveBioAgentStatus = (status)=>{
    const value = String(status || '').trim().toLowerCase();
    return value === 'running' || value === 'paused';
};
const $8420f99a62349403$var$setBioAgentsNavCount = (count)=>{
    const safeCount = Math.max(0, Math.floor(Number.isFinite(Number(count)) ? Number(count) : 0));
    const label = safeCount > 9 ? '9+' : String(safeCount);
    const countEl = (0, $67bV2.getid)('bioAgentsActiveCount');
    const bioAgentsBtn = (0, $67bV2.getid)('bio_agents_btn');
    if (countEl) countEl.textContent = label;
    if (bioAgentsBtn) {
        const activeText = safeCount === 1 ? '1 active Bio Agent' : `${label} active Bio Agents`;
        bioAgentsBtn.setAttribute('aria-label', `Bio Agents, ${activeText}`);
        bioAgentsBtn.title = `Bio Agents: ${activeText}`;
    }
};
let $8420f99a62349403$var$bioAgentsNavCountSeq = 0;
let $8420f99a62349403$var$bioAgentsNavCountPromise = null;
let $8420f99a62349403$var$bioAgentsNavCountRequestToken = null;
let $8420f99a62349403$var$bioAgentsNavCountFailures = 0;
let $8420f99a62349403$var$bioAgentsNavCountTimer = null;
const $8420f99a62349403$var$clearBioAgentsNavCountTimer = ()=>{
    if ($8420f99a62349403$var$bioAgentsNavCountTimer === null) return;
    window.clearTimeout($8420f99a62349403$var$bioAgentsNavCountTimer);
    $8420f99a62349403$var$bioAgentsNavCountTimer = null;
};
const $8420f99a62349403$var$canPollBioAgentsNavCount = ()=>{
    return !!(0, $67bV2.getLoginFlag)() && !!(0, $67bV2.canShowBioAgentsNav)();
};
const $8420f99a62349403$var$bioAgentsNavCountDelay = ()=>{
    const multiplier = Math.min(4, 2 ** Math.max(0, $8420f99a62349403$var$bioAgentsNavCountFailures));
    return Math.min($8420f99a62349403$var$BIO_AGENT_NAV_COUNT_BACKOFF_MAX_MS, $8420f99a62349403$var$BIO_AGENT_NAV_COUNT_POLL_MS * multiplier);
};
function $8420f99a62349403$var$scheduleBioAgentsNavCountPoll(delayMs = null) {
    $8420f99a62349403$var$clearBioAgentsNavCountTimer();
    if (!$8420f99a62349403$var$canPollBioAgentsNavCount()) {
        $8420f99a62349403$var$bioAgentsNavCountSeq += 1;
        $8420f99a62349403$var$bioAgentsNavCountRequestToken = null;
        $8420f99a62349403$var$bioAgentsNavCountPromise = null;
        $8420f99a62349403$var$setBioAgentsNavCount(0);
        return;
    }
    if (document.hidden) return;
    const delay = delayMs === null ? $8420f99a62349403$var$bioAgentsNavCountDelay() : Math.max(0, Number(delayMs) || 0);
    $8420f99a62349403$var$bioAgentsNavCountTimer = window.setTimeout(async ()=>{
        $8420f99a62349403$var$bioAgentsNavCountTimer = null;
        await $8420f99a62349403$var$refreshBioAgentsNavCount();
        $8420f99a62349403$var$scheduleBioAgentsNavCountPoll();
    }, delay);
}
function $8420f99a62349403$var$wakeBioAgentsNavCountPoll() {
    if (document.hidden) {
        $8420f99a62349403$var$clearBioAgentsNavCountTimer();
        return;
    }
    $8420f99a62349403$var$scheduleBioAgentsNavCountPoll(0);
}
async function $8420f99a62349403$var$refreshBioAgentsNavCount() {
    if (!$8420f99a62349403$var$canPollBioAgentsNavCount()) {
        $8420f99a62349403$var$bioAgentsNavCountSeq += 1;
        $8420f99a62349403$var$bioAgentsNavCountRequestToken = null;
        $8420f99a62349403$var$bioAgentsNavCountPromise = null;
        $8420f99a62349403$var$setBioAgentsNavCount(0);
        return 0;
    }
    if (document.hidden) return 0;
    if ($8420f99a62349403$var$bioAgentsNavCountPromise) return $8420f99a62349403$var$bioAgentsNavCountPromise;
    const seq = ++$8420f99a62349403$var$bioAgentsNavCountSeq;
    const token = {};
    $8420f99a62349403$var$bioAgentsNavCountRequestToken = token;
    const promise = (async ()=>{
        try {
            const data = await $9MHdv.listBioAgentThreads('all');
            if (seq !== $8420f99a62349403$var$bioAgentsNavCountSeq) return 0;
            const threads = Array.isArray(data?.threads) ? data.threads : [];
            const activeCount = threads.filter((thread)=>$8420f99a62349403$var$isActiveBioAgentStatus(thread?.status)).length;
            $8420f99a62349403$var$setBioAgentsNavCount(activeCount);
            $8420f99a62349403$var$bioAgentsNavCountFailures = 0;
            return activeCount;
        } catch (err) {
            if (seq === $8420f99a62349403$var$bioAgentsNavCountSeq) {
                $8420f99a62349403$var$bioAgentsNavCountFailures = Math.min($8420f99a62349403$var$bioAgentsNavCountFailures + 1, 6);
                $8420f99a62349403$var$setBioAgentsNavCount(0);
            }
            return 0;
        }
    })();
    $8420f99a62349403$var$bioAgentsNavCountPromise = promise;
    promise.finally(()=>{
        if ($8420f99a62349403$var$bioAgentsNavCountRequestToken === token) {
            $8420f99a62349403$var$bioAgentsNavCountRequestToken = null;
            $8420f99a62349403$var$bioAgentsNavCountPromise = null;
        }
    });
    return promise;
}
window.refreshBioAgentsNavCount = $8420f99a62349403$var$refreshBioAgentsNavCount;
// Event listeners initialization
function $8420f99a62349403$var$initEventListeners() {
    const themeLink = document.getElementById('themeStylesheet');
    let activeTheme = null;
    const applyTheme = (theme)=>{
        const nextTheme = theme === 'light' ? 'light' : 'dark';
        if (themeLink) {
            const url = new URL(themeLink.href, window.location.href);
            const search = url.search || '';
            const href = nextTheme === 'light' ? `/css/light.css${search}` : `/css/dark.css${search}`;
            if (!themeLink.href.endsWith(href)) themeLink.href = href;
        }
        localStorage.setItem('theme', nextTheme);
        const toggle = document.getElementById('themeToggle');
        if (toggle && toggle instanceof HTMLInputElement) toggle.checked = nextTheme === 'light';
        if (activeTheme !== nextTheme) {
            activeTheme = nextTheme;
            document.dispatchEvent(new CustomEvent('themechange', {
                detail: {
                    theme: nextTheme
                }
            }));
        }
    };
    // Apply saved theme early in init (default to light)
    let initialTheme = 'light';
    try {
        const stored = localStorage.getItem('theme');
        if (stored === 'light' || stored === 'dark') initialTheme = stored;
    } catch  {}
    applyTheme(initialTheme);
    const loginContainer = (0, $67bV2.getid)('loginContainer');
    const creditsInputContainer = (0, $67bV2.getid)('creditsInputContainer');
    const accountMenu = (0, $67bV2.getid)('accountMenu');
    const teamMenu = (0, $67bV2.getid)('teamMenu');
    const screenOverlay = document.getElementById('screenOverlay');
    const isMobile = ()=>window.matchMedia && window.matchMedia('(max-width: 768px)').matches;
    const sidePane = (0, $67bV2.getid)('sidePane');
    const sidePaneStorageKey = 'ssq_sidepane_open';
    const dropdownMenus = [
        loginContainer,
        creditsInputContainer,
        accountMenu,
        teamMenu
    ].filter(Boolean);
    const dropdownOpen = (el)=>!!el && !el.classList.contains('hidden');
    const hideDropdowns = (except = null)=>dropdownMenus.forEach((el)=>{
            if (el !== except) el.classList.add('hidden');
        });
    const persistSidePane = ()=>{
        if (!sidePane || isMobile()) return;
        try {
            localStorage.setItem(sidePaneStorageKey, sidePane.classList.contains('show') ? '1' : '0');
        } catch  {}
    };
    const restoreSidePane = ()=>{
        if (!sidePane || isMobile()) return;
        let shouldShow = true;
        try {
            const saved = localStorage.getItem(sidePaneStorageKey);
            if (saved === '0' || saved === '1') shouldShow = saved === '1';
        } catch  {}
        sidePane.classList.toggle('show', shouldShow);
    };
    const anyDropdownOpen = ()=>dropdownMenus.some(dropdownOpen) || sidePane && sidePane.classList.contains('show');
    restoreSidePane();
    const updateOverlay = ()=>{
        if (!screenOverlay) return;
        const show = isMobile() && anyDropdownOpen();
        screenOverlay.classList.toggle('hidden', !show);
        if (show) screenOverlay.addEventListener('click', closeAll, {
            once: true
        });
    };
    const closeAll = ()=>{
        hideDropdowns();
        sidePane?.classList.remove('show');
        updateOverlay();
    };
    const toggleDropdown = (target)=>{
        target.classList.toggle('hidden');
        hideDropdowns(target);
        if (isMobile() && dropdownOpen(target)) sidePane?.classList.remove('show');
        updateOverlay();
    };
    const navigateAndHide = (path, menu)=>{
        window.navigate(path);
        menu?.classList.add('hidden');
        updateOverlay();
    };
    const confirmLogout = async ()=>{
        const impersonating = (0, $67bV2.state).isOwner && !!(0, $67bV2.state).viewAsEmail;
        const ok = await (0, $lvi95.openConfirmModal)({
            title: impersonating ? 'Exit Impersonation' : 'Logout',
            message: impersonating ? 'Exit this impersonated account?' : 'Are you sure you want to log out?',
            confirmText: impersonating ? 'Exit' : 'Logout',
            cancelText: 'Cancel'
        });
        if (ok) await $9MHdv.logout();
    };
    // Login dropdown toggle
    (0, $67bV2.getid)('loginButton').addEventListener('click', (e)=>{
        e.stopPropagation();
        toggleDropdown(loginContainer);
    });
    (0, $67bV2.getid)('credits-disp').addEventListener('click', (e)=>{
        e.stopPropagation();
        if (!(0, $67bV2.getLoginFlag)()) return;
        if ((0, $67bV2.state).activeTeamId && !(0, $67bV2.isActiveTeamAdmin)()) {
            creditsInputContainer.classList.add('hidden');
            updateOverlay();
            return;
        }
        toggleDropdown(creditsInputContainer);
    });
    (0, $67bV2.getid)('email-disp').addEventListener('click', (e)=>{
        e.stopPropagation();
        if (!(0, $67bV2.getLoginFlag)()) return;
        toggleDropdown(accountMenu);
    });
    // Close login container when clicking outside
    document.addEventListener('click', (e)=>{
        if (!loginContainer.contains(e.target) && e.target !== (0, $67bV2.getid)('loginButton')) loginContainer.classList.add('hidden');
        if (!creditsInputContainer.contains(e.target) && e.target !== (0, $67bV2.getid)('credits-disp')) creditsInputContainer.classList.add('hidden');
        if (!accountMenu.contains(e.target) && e.target !== (0, $67bV2.getid)('email-disp')) accountMenu.classList.add('hidden');
        if (!teamMenu.contains(e.target) && e.target !== (0, $67bV2.getid)('activeTeamDisplay')) teamMenu.classList.add('hidden');
        updateOverlay();
    });
    const OTP_RESEND_SECONDS = 30;
    let otpResendTimer = null;
    let otpRequestInFlight = false;
    const showOTPEntry = ()=>{
        (0, $67bV2.getid)('e-group').classList.add('hidden');
        (0, $67bV2.getid)('o-group').classList.remove('hidden');
        (0, $67bV2.getid)('otpInput').focus();
    };
    const setOTPResendCooldown = (seconds = OTP_RESEND_SECONDS)=>{
        const btn = (0, $67bV2.getid)('otpResend');
        if (!btn) return;
        if (otpResendTimer) {
            clearInterval(otpResendTimer);
            otpResendTimer = null;
        }
        let remaining = Math.max(0, Math.ceil(Number(seconds) || 0));
        const reset = ()=>{
            btn.disabled = false;
            btn.textContent = 'Send again';
        };
        if (remaining <= 0) {
            reset();
            return;
        }
        const tick = ()=>{
            if (remaining <= 0) {
                clearInterval(otpResendTimer);
                otpResendTimer = null;
                reset();
                return;
            }
            btn.disabled = true;
            btn.textContent = `Send again (${remaining}s)`;
            remaining -= 1;
        };
        tick();
        otpResendTimer = setInterval(tick, 1000);
    };
    const requestLoginCode = async (email, button, { resend: resend = false } = {})=>{
        const cleanEmail = String(email || '').trim().toLowerCase();
        if (!cleanEmail) return false;
        if (otpRequestInFlight) return false;
        otpRequestInFlight = true;
        const originalText = button ? button.textContent : '';
        if (button) {
            button.disabled = true;
            button.textContent = 'Sending...';
        }
        let ok = false;
        try {
            const result = await $9MHdv.reqOTP(cleanEmail, {
                resend: resend
            });
            if (result) {
                ok = true;
                showOTPEntry();
                const retryAfter = Number(result.retry_after_seconds);
                setOTPResendCooldown(Number.isFinite(retryAfter) ? retryAfter : OTP_RESEND_SECONDS);
            }
            return result;
        } finally{
            otpRequestInFlight = false;
            if (button && (button.id !== 'otpResend' || !ok)) {
                button.disabled = false;
                button.textContent = originalText;
            }
        }
    };
    (0, $67bV2.getid)('emailSubmit').addEventListener('click', async (e)=>{
        await requestLoginCode((0, $67bV2.getid)('emailInput').value, e.currentTarget);
    });
    (0, $67bV2.getid)('otpResend').addEventListener('click', async (e)=>{
        const email = (0, $67bV2.state).tempEmail || (0, $67bV2.getid)('emailInput').value;
        await requestLoginCode(email, e.currentTarget, {
            resend: true
        });
    });
    const toggleSidePane = (e)=>{
        e.preventDefault();
        const sp = sidePane;
        if (!sp) return;
        const willShow = !sp.classList.contains('show');
        sp.classList.toggle('show');
        // If opening sidebar on mobile, hide any open dropdowns
        if (isMobile() && willShow) {
            loginContainer.classList.add('hidden');
            creditsInputContainer.classList.add('hidden');
            accountMenu.classList.add('hidden');
        }
        updateOverlay();
        persistSidePane();
    };
    (0, $67bV2.getid)('menuToggle').addEventListener('click', toggleSidePane);
    const titleLink = document.getElementById('titleLink');
    if (titleLink) titleLink.addEventListener('click', (e)=>{
        if (isMobile()) toggleSidePane(e);
        else window.navigate('/');
    });
    (0, $67bV2.getid)('otpSubmit').addEventListener('click', async ()=>{
        const otp = (0, $67bV2.getid)('otpInput').value.trim();
        await $9MHdv.login(otp);
        (0, $67bV2.updateUserDisplay)();
    });
    // Theme toggle
    const themeBtn = document.getElementById('themeToggle');
    if (themeBtn && themeBtn instanceof HTMLInputElement) themeBtn.addEventListener('change', (e)=>{
        const checked = e.target.checked;
        applyTheme(checked ? 'light' : 'dark');
    });
    (0, $67bV2.getid)('logout_btn').addEventListener('click', async ()=>{
        await confirmLogout();
    });
    // Account dropdown actions
    (0, $67bV2.getid)('accountTxsBtn').addEventListener('click', ()=>{
        navigateAndHide('/funding', accountMenu);
    });
    const keysBtn = (0, $67bV2.getid)('accountKeysBtn');
    if (keysBtn) keysBtn.addEventListener('click', ()=>{
        navigateAndHide('/keys', accountMenu);
    });
    const teamsBtn = (0, $67bV2.getid)('accountTeamsBtn');
    if (teamsBtn) teamsBtn.addEventListener('click', ()=>{
        navigateAndHide('/teams', accountMenu);
    });
    const activeTeamDisplay = (0, $67bV2.getid)('activeTeamDisplay');
    if (activeTeamDisplay) activeTeamDisplay.addEventListener('click', (e)=>{
        e.stopPropagation();
        if (!(0, $67bV2.getLoginFlag)() || !(0, $67bV2.state).activeTeamId) return;
        toggleDropdown(teamMenu);
    });
    const projectFocusClear = (0, $67bV2.getid)('projectFocusClear');
    if (projectFocusClear) projectFocusClear.addEventListener('click', (e)=>{
        e.preventDefault();
        e.stopPropagation();
        (0, $67bV2.clearActiveProjectFocus)();
        if (typeof window.route === 'function') window.route();
    });
    const teamManageBtn = (0, $67bV2.getid)('teamManageBtn');
    if (teamManageBtn) teamManageBtn.addEventListener('click', ()=>{
        navigateAndHide('/team', teamMenu);
    });
    const teamFundingBtn = (0, $67bV2.getid)('teamFundingBtn');
    if (teamFundingBtn) teamFundingBtn.addEventListener('click', ()=>{
        navigateAndHide('/funding', teamMenu);
    });
    const teamKeysBtn = (0, $67bV2.getid)('teamKeysBtn');
    if (teamKeysBtn) teamKeysBtn.addEventListener('click', ()=>{
        navigateAndHide('/keys', teamMenu);
    });
    const teamExitBtn = (0, $67bV2.getid)('teamExitBtn');
    if (teamExitBtn) teamExitBtn.addEventListener('click', async ()=>{
        teamMenu.classList.add('hidden');
        updateOverlay();
        const ok = await (0, $bilr3.confirmAndSetActiveTeamId)(0);
        if (!ok) return;
        try {
            await $9MHdv.loadUserInfo();
            (0, $67bV2.updateUserDisplay)();
            if (typeof window.route === 'function') window.route();
        } catch (err) {
            console.warn('Failed to exit team scope:', err);
        }
    });
    (0, $67bV2.getid)('accountLogoutBtn').addEventListener('click', async ()=>{
        accountMenu.classList.add('hidden');
        await confirmLogout();
    });
    const isBioAgentExperimentEnabled = ()=>{
        try {
            return localStorage.getItem($8420f99a62349403$var$BIO_AGENT_EXPERIMENT_ACK_KEY) === '1' || localStorage.getItem($8420f99a62349403$var$BIO_AGENT_EXPERIMENT_LEGACY_ACK_KEY) === '1';
        } catch  {
            return false;
        }
    };
    const setBioAgentExperimentEnabled = (enabled)=>{
        try {
            if (enabled) localStorage.setItem($8420f99a62349403$var$BIO_AGENT_EXPERIMENT_ACK_KEY, '1');
            else {
                localStorage.removeItem($8420f99a62349403$var$BIO_AGENT_EXPERIMENT_ACK_KEY);
                localStorage.removeItem($8420f99a62349403$var$BIO_AGENT_EXPERIMENT_LEGACY_ACK_KEY);
            }
        } catch  {}
    };
    let bioAgentConsentPromptOpen = false;
    const ensureBioAgentExperimentConsent = async ()=>{
        if (isBioAgentExperimentEnabled()) return true;
        if (bioAgentConsentPromptOpen) return false;
        bioAgentConsentPromptOpen = true;
        try {
            const ok = await (0, $lvi95.openConfirmModal)({
                title: 'Enable Bio Agents',
                message: 'Bio Agents can use tools, including data deletion and running jobs which use your credits. (You can also use the <a href="/docs/mcp">MCP server</a> with custom agents for more control.) Enable if you accept these risks.',
                confirmText: 'Enable',
                cancelText: 'Cancel'
            });
            if (ok) {
                setBioAgentExperimentEnabled(true);
                return true;
            }
            return false;
        } finally{
            bioAgentConsentPromptOpen = false;
        }
    };
    const handleBioAgentsNavClick = async (event)=>{
        if (event && typeof event.preventDefault === 'function') event.preventDefault();
        const consented = await ensureBioAgentExperimentConsent();
        if (!consented) return;
        window.navigate('/bio-agents');
    };
    window.handleBioAgentsNavClick = handleBioAgentsNavClick;
    const bioAgentsBtn = (0, $67bV2.getid)('bio_agents_btn');
    if (bioAgentsBtn) bioAgentsBtn.onclick = handleBioAgentsNavClick;
    document.addEventListener('visibilitychange', ()=>{
        if (document.hidden) $8420f99a62349403$var$clearBioAgentsNavCountTimer();
        else $8420f99a62349403$var$wakeBioAgentsNavCountPoll();
    });
    document.addEventListener('ssq-user-display-changed', ()=>$8420f99a62349403$var$wakeBioAgentsNavCountPoll());
    window.addEventListener('focus', ()=>$8420f99a62349403$var$wakeBioAgentsNavCountPoll());
    $8420f99a62349403$var$scheduleBioAgentsNavCountPoll(0);
    document.querySelectorAll('.nav-btn').forEach((el)=>{
        el.addEventListener('click', (e)=>{
            if (isMobile() && sidePane) sidePane.classList.remove('show');
        });
    });
    const creditsInput = (0, $67bV2.getid)('creditsInput');
    const creditsSubmit = (0, $67bV2.getid)('creditsSubmit');
    let paymentTopUpMaxCredits = null;
    $9MHdv.getPricing().then((pricing)=>{
        const max = Number(pricing?.top_up_max_credits);
        if (Number.isFinite(max) && max > 0) {
            paymentTopUpMaxCredits = Math.floor(max);
            creditsInput.max = String(paymentTopUpMaxCredits);
        }
    }).catch(()=>{});
    creditsSubmit.addEventListener('click', async ()=>{
        let amount = parseInt(creditsInput.value);
        if (isNaN(amount) || amount < 1) return;
        if (paymentTopUpMaxCredits != null && amount > paymentTopUpMaxCredits) {
            amount = paymentTopUpMaxCredits;
            creditsInput.value = String(amount);
        }
        await $9MHdv.addCredits(amount);
    });
    const clickOnEnter = (input, button)=>input?.addEventListener('keypress', (e)=>{
            if (e.key === 'Enter') button?.click();
        });
    clickOnEnter(creditsInput, creditsSubmit);
    creditsInput.addEventListener('input', (e)=>{
        e.target.value = Math.round(e.target.value);
        // Keep browser input aligned with the server-advertised payment bounds.
        if (e.target.value < 0) e.target.value = 0;
        if (paymentTopUpMaxCredits != null && e.target.value > paymentTopUpMaxCredits) e.target.value = paymentTopUpMaxCredits;
    });
    clickOnEnter((0, $67bV2.getid)('emailInput'), (0, $67bV2.getid)('emailSubmit'));
    clickOnEnter((0, $67bV2.getid)('otpInput'), (0, $67bV2.getid)('otpSubmit'));
}
// Adjust header layout on mobile: center title when header-buttons wrap
function $8420f99a62349403$var$updateHeaderLayout() {
    try {
        const header = document.querySelector('.header');
        const title = document.querySelector('.title-menu');
        const right = document.querySelector('.header-buttons');
        if (!header || !title || !right) return;
        const isMobile = window.matchMedia && window.matchMedia('(max-width: 768px)').matches;
        const loggedIn = !!(0, $67bV2.getLoginFlag)();
        // Force two rows on mobile when logged in; otherwise detect wrap
        let twoRows = isMobile && loggedIn;
        if (!twoRows) {
            const rt = right.getBoundingClientRect().top;
            const tt = title.getBoundingClientRect().top;
            twoRows = right.offsetTop > title.offsetTop + 2 || rt - tt > 4 || header.scrollWidth > header.clientWidth;
        }
        header.classList.toggle('two-rows', twoRows);
    } catch  {}
}
// Expose for cross-module updates (e.g., after login/logout UI changes)
// This lets globals js request a layout recalculation after it toggles header elements
window.updateHeaderLayout = $8420f99a62349403$var$updateHeaderLayout;
// Initialize app
document.addEventListener('DOMContentLoaded', async ()=>{
    $8420f99a62349403$var$initEventListeners();
    // Reflect current auth state immediately
    try {
        (0, $67bV2.updateUserDisplay)();
    } catch  {}
    // Magic link login (email + otp in query string)
    try {
        const params = new URLSearchParams(window.location.search);
        const magicOTP = params.get('otp');
        const magicEmail = params.get('email');
        const hasMagic = params.get('magic') === '1' || magicOTP && magicEmail;
        if (hasMagic && magicOTP && magicEmail) {
            (0, $67bV2.state).tempEmail = magicEmail;
            const url = new URL(window.location.href);
            url.searchParams.delete('magic');
            url.searchParams.delete('email');
            url.searchParams.delete('otp');
            window.history.replaceState({}, '', url.pathname + url.search);
            await $9MHdv.login(magicOTP);
            (0, $67bV2.updateUserDisplay)();
        }
    } catch  {}
    // If logged in, fetch user info (email/credits) and refresh header
    try {
        if ((0, $67bV2.getLoginFlag)()) {
            await $9MHdv.loadUserInfo();
            (0, $67bV2.updateUserDisplay)();
        }
    } catch  {}
    // If redirected back from Stripe, verify payment and refresh credits
    try {
        const params = new URLSearchParams(window.location.search);
        if (params.get('payment') === 'success') {
            const sessionId = params.get('session_id');
            const txId = params.get('tx');
            if (sessionId && txId && (0, $67bV2.getLoginFlag)()) {
                await $9MHdv.verifyPayment(sessionId, txId);
                await $9MHdv.loadUserInfo();
                (0, $67bV2.updateUserDisplay)();
            }
            // Clean URL
            const url = new URL(window.location.href);
            url.searchParams.delete('payment');
            url.searchParams.delete('session_id');
            url.searchParams.delete('tx');
            window.history.replaceState({}, '', url.pathname + url.search);
            // Navigate to funding history for visibility
            window.navigate('/funding');
        }
    } catch  {}
});


// Desktop-only decorative amino acid banner.
const $7db6ea29ce7427f2$var$SEQ_FILES = [
    '/sequences/placeholder1.txt',
    '/sequences/placeholder2.txt',
    '/sequences/placeholder3.txt'
];
const $7db6ea29ce7427f2$var$DISPLAY_SEQ_LEN = 520;
function $7db6ea29ce7427f2$var$pick(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
}
function $7db6ea29ce7427f2$var$randInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}
// Generate non-overlapping colored segments across the sequence
function $7db6ea29ce7427f2$var$makeSegments(n, opts = {}) {
    const { minLen: minLen = 10, maxLen: maxLen = 40, coverage: coverage = 0.35 } = opts;
    const segs = [];
    let covered = 0;
    let i = 0;
    // Walk forward to avoid overlaps; randomly skip gaps
    while(i < n && covered / n < coverage){
        // random gap before next domain
        i += $7db6ea29ce7427f2$var$randInt(5, 35);
        if (i >= n) break;
        const len = Math.min($7db6ea29ce7427f2$var$randInt(minLen, maxLen), n - i);
        segs.push([
            i,
            i + len
        ]);
        covered += len;
        i += len;
    }
    return segs;
}
function $7db6ea29ce7427f2$var$randomColorHsla() {
    const hue = $7db6ea29ce7427f2$var$randInt(0, 359);
    const sat = $7db6ea29ce7427f2$var$randInt(45, 75);
    const light = $7db6ea29ce7427f2$var$randInt(55, 70);
    const alpha = 0.5;
    return `hsla(${hue} ${sat}% ${light}% / ${alpha})`;
}
function $7db6ea29ce7427f2$var$randomSequenceWindow(seq) {
    if (!seq) return '';
    const start = $7db6ea29ce7427f2$var$randInt(0, Math.max(0, seq.length - 1));
    const rotated = `${seq.slice(start)}${seq.slice(0, start)}`;
    let out = rotated;
    while(out.length < $7db6ea29ce7427f2$var$DISPLAY_SEQ_LEN)out += rotated;
    return out.slice(0, $7db6ea29ce7427f2$var$DISPLAY_SEQ_LEN);
}
function $7db6ea29ce7427f2$var$colorizeSequence(seq) {
    const L = seq.length;
    const segments = $7db6ea29ce7427f2$var$makeSegments(L, {
        minLen: 12,
        maxLen: 48,
        coverage: 0.4
    });
    // Assign a color per segment
    const colors = segments.map(()=>$7db6ea29ce7427f2$var$randomColorHsla());
    // Build HTML by chunks to avoid per-letter span overhead
    let html = '';
    let cursor = 0;
    segments.forEach(([s, e], idx)=>{
        if (s > cursor) html += seq.slice(cursor, s);
        const colored = seq.slice(s, e);
        const color = colors[idx];
        html += `<span class="aa-dom" style="color:${color}">${colored}</span>`;
        cursor = e;
    });
    if (cursor < L) html += seq.slice(cursor);
    return html;
}
async function $7db6ea29ce7427f2$var$initBanner() {
    // Skip only on true small screens; otherwise allow if there's room
    const small = window.matchMedia && window.matchMedia('(max-width: 640px)').matches;
    if (small) return;
    const host = document.querySelector('.aa-banner');
    if (!host) return;
    // If the banner area is too narrow, skip work
    if (host.offsetWidth < 160) return;
    const seq1 = document.querySelector('.aa-seq-1');
    const seq2 = document.querySelector('.aa-seq-2');
    if (!seq1 || !seq2) return;
    try {
        const file = $7db6ea29ce7427f2$var$pick($7db6ea29ce7427f2$var$SEQ_FILES);
        const resp = await fetch(file, {
            cache: 'no-store'
        });
        if (!resp.ok) throw new Error('sequence fetch failed');
        const raw = (await resp.text()).toUpperCase();
        // Keep only AA letters
        const seq = raw.replace(/[^ACDEFGHIKLMNPQRSTVWY]/g, '');
        if (!seq || seq.length < 80) return; // too short to look good
        const base = $7db6ea29ce7427f2$var$randomSequenceWindow(seq);
        const colored = $7db6ea29ce7427f2$var$colorizeSequence(base);
        seq1.innerHTML = colored;
        seq2.textContent = '';
    } catch (e) {
    // Decorative only; fail silently
    }
}
document.addEventListener('DOMContentLoaded', $7db6ea29ce7427f2$var$initBanner);


parcelRequire("irHXR");


//# sourceMappingURL=websrc.856a00ab.js.map
